package repdb

import androidx.paging.PagingSource
import com.ustadmobile.door.entities.DoorNode
import com.ustadmobile.door.ext.doorPrimaryKeyManager
import com.ustadmobile.door.ext.rootDatabase
import com.ustadmobile.door.room.RoomDatabase
import com.ustadmobile.door.util.systemTimeInMillis
import kotlin.IllegalStateException
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow

public class RepDao_DoorWrapper(
  private val _db: RoomDatabase,
  private val _dao: RepDao,
) : RepDao {
  override suspend fun insertDoorNodeAsync(node: DoorNode) {
    _dao.insertDoorNodeAsync(node)
  }

  override fun insertDoorNode(node: DoorNode): Unit = throw
      IllegalStateException("insertDoorNode: synchronous db access is NOT possible on Javascript!")

  override suspend fun insertAsync(repEntity: RepEntity): Long {
    val _pkManager = _db.rootDatabase.doorPrimaryKeyManager
    if(repEntity.rePrimaryKey == 0L) {
      val _newPk = _pkManager.nextIdAsync(500)
      repEntity.rePrimaryKey = _newPk
    }
    repEntity.reLastChangeTime = systemTimeInMillis()
    //must set versionid and/or primary key here
    _dao.insertAsync(repEntity)
    return repEntity.rePrimaryKey
  }

  override fun insert(repEntity: RepEntity): Long = throw
      IllegalStateException("insert: synchronous db access is NOT possible on Javascript!")

  override fun insertList(repEntityList: List<RepEntity>): Unit = throw
      IllegalStateException("insertList: synchronous db access is NOT possible on Javascript!")

  override fun update(repEntity: RepEntity): Unit = throw
      IllegalStateException("update: synchronous db access is NOT possible on Javascript!")

  override suspend fun updateAsync(repEntity: RepEntity) {
    repEntity.reLastChangeTime = systemTimeInMillis()
    //must set versionid and/or primary key here
    _dao.updateAsync(repEntity)
  }

  override fun countEntities(): Int = throw
      IllegalStateException("countEntities: synchronous db access is NOT possible on Javascript!")

  override fun findByUid(uid: Long): RepEntity? = throw
      IllegalStateException("findByUid: synchronous db access is NOT possible on Javascript!")

  override suspend fun findByUidAsync(uid: Long): RepEntity? = _dao.findByUidAsync(uid)

  override suspend fun findAllAsync(): List<RepEntity> = _dao.findAllAsync()

  override suspend fun insertHttp(entity: RepEntity): Long {
    val _pkManager = _db.rootDatabase.doorPrimaryKeyManager
    if(entity.rePrimaryKey == 0L) {
      val _newPk = _pkManager.nextIdAsync(500)
      entity.rePrimaryKey = _newPk
    }
    entity.reLastChangeTime = systemTimeInMillis()
    //must set versionid and/or primary key here
    _dao.insertHttp(entity)
    return entity.rePrimaryKey
  }

  override suspend fun selectSyncNodeId(): Long = _dao.selectSyncNodeId()

  override suspend fun findInStringList(strList: List<String>): List<RepEntity> =
      _dao.findInStringList(strList)

  override suspend fun sqliteOnlyFun(num1: Int, num2: Int): Long = _dao.sqliteOnlyFun(num1, num2)

  override fun findAllAsFlow(): Flow<List<RepEntity>> = _dao.findAllAsFlow()

  override fun findAllPaged(): PagingSource<Int, RepEntity> = _dao.findAllPaged()

  public override fun interfaceInsertFun(entity: RepEntity): Unit = throw
      IllegalStateException("interfaceInsertFun: synchronous db access is NOT possible on Javascript!")
}
